/* IMPORT */
import { UNAVAILABLE } from '../constants.js';
import { OBSERVER, setObserver } from '../context.js';
import { lazyArrayEachRight } from '../lazy.js';
import { castError } from '../utils.js';
import { callStack, Stack } from '../methods/debugger.js';
import { OWNER, setOwner } from './superroot.js';
/* HELPERS */
const onCleanup = (cleanup) => cleanup.call(cleanup, callStack());
const onDispose = (owner) => owner.dispose(true);
/* MAIN */
//TODO: Throw when registering stuff after disposing, maybe
class Owner {
    constructor() {
        /* VARIABLES */
        this.disposed = false;
        this.cleanups = undefined;
        this.errorHandler = undefined;
        this.contexts = undefined;
        this.observers = undefined;
        this.roots = undefined;
        this.suspenses = undefined;
    }
    /* API */
    catch(error, silent) {
        const { errorHandler } = this;
        if (errorHandler) {
            errorHandler(error); //TODO: This assumes that the error handler won't throw immediately, which we know, but Owner shouldn't know
            return true;
        }
        else {
            if (this.parent?.catch(error, true))
                return true;
            if (silent)
                return false;
            // console.error ( error.stack ); // <-- Log "error.stack" to better understand where the error happened
            throw error;
        }
    }
    dispose(deep) {
        lazyArrayEachRight(this.contexts, onDispose);
        lazyArrayEachRight(this.observers, onDispose);
        lazyArrayEachRight(this.suspenses, onDispose);
        lazyArrayEachRight(this.cleanups, onCleanup);
        this.cleanups = undefined;
        this.disposed = deep;
        this.errorHandler = undefined;
        this.observers = undefined;
        this.suspenses = undefined;
    }
    get(symbol) {
        return this.context?.[symbol];
    }
    wrap(fn, owner, observer, stack) {
        const ownerPrev = OWNER;
        const observerPrev = OBSERVER;
        setOwner(owner);
        setObserver(observer);
        try {
            return fn(stack);
        }
        catch (error) {
            this.catch(castError(error), false); // Bubbling the error up
            return UNAVAILABLE; // Returning a value that is the least likely to cause bugs
        }
        finally {
            setOwner(ownerPrev);
            setObserver(observerPrev);
        }
    }
}
/* EXPORT */
export default Owner;
